var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hips_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hips_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hips_svg__st0",
    d: "M118 43.6s-13.5 13.2-44.3 13.2c-30.7 0-44.3-13.2-44.3-13.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hips_svg__st0",
    d: "M26.7 55.6c19.2 12.7 29.6 11.5 43.8 29 .8 1 2.1 1.5 3.3 1.5 1.2 0 2.5-.5 3.3-1.5 14.2-17.4 24.6-16.3 43.8-29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 60.9c6.5 4.3 12.7 10.1 19.6 18.2 6.9-8.1 13.2-14 19.7-18.3-5.7 1.2-12.2 1.9-19.7 1.9-7.5.1-14-.6-19.6-1.8z",
    fill: "var(--color-icon-primary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "hips_svg__st0",
    d: "M82.3 131.1l-8.5-45M65.3 132.1L71 97.2M45.2 92.9c-19.1-2.5-32.6-8.3-32.6-15.3 0-2.6 2-5.2 5.5-7.4M48.3 85.6l6.1 8.7-8.2 6.5M103 92.9c19.2-2.5 32.7-8.5 32.7-15.4 0-2.7-2-5.3-5.7-7.5M99.9 85.6l-6.1 8.7 8.2 6.5M24.5 88.1l5.1 44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "hips_svg__st0",
    d: "M35 16.9c-2.3 10.8-1.9 17-4.4 23.6-4.8 12.8-7 26.3-6.6 39.9M123.5 87.9c1.6-16-.3-32.3-6.1-47.4-2.8-7.4-2.4-14.6-4.4-24.6M118.4 131.1s2.5-20.4 4.3-35.7"
  })));
}
export default SvgHips;